export default __webpack_public_path__ + "94af8c8024fd9c9d54546439e21c2806.svg";